export default __webpack_public_path__ + "static/media/bee-animation.db56de5b.gif";